module.exports = __webpack_public_path__ + "img/jiankong.610c5497.png";